import { ArrowForward } from "@mui/icons-material"
import MatButton from "@mui/material/Button"
import { ButtonProps as MatButtonProps } from "@mui/material/Button"

import React, { FC } from "react"

import { Loading } from "src/components/common/loading"
import { create } from "src/helpers/bem"

import styles from "./Button.module.scss"

const bem = create(styles, "Button")
export type ButtonType = "primary" | "secondary" | undefined

export type ButtonProps = MatButtonProps & {
  loading?: boolean
  buttonType?: ButtonType
}

export const Button: FC<ButtonProps> = ({
  loading,
  variant = "outlined",
  size = "large",
  color,
  title,
  buttonType,
  endIcon,
  ...props
}) => (
  <MatButton
    {...props}
    className={bem(props.className, undefined, `Button__${buttonType}`)}
    color={color}
    endIcon={endIcon ? <ArrowForward className={bem("icon")} /> : undefined}
    variant={variant}
  >
    {!loading ? title : <Loading color="info" size={24} />}
  </MatButton>
)
